import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  FETCH_RULES_REQUEST,
  fetchRulesSuccess,
  fetchRulesFailure,
  CREATE_RULE_REQUEST,
  createRuleSuccess,
  createRuleFailure,
  UPDATE_RULE_REQUEST,
  updateRuleSuccess,
  updateRuleFailure,
  DELETE_RULE_REQUEST,
  deleteRuleSuccess,
  deleteRuleFailure,
} from "../actions/ruleActions";
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem("authToken");

const createConfig = () => ({
  headers: { Authorization: `Bearer ${authToken}` },
});

function* fetchRules(action) {
  try {
    const response = yield call(
      axios.get,
      `${API_BASE_URL}/${action.payload}/rules`,
      createConfig()
    );
    yield put(fetchRulesSuccess(response.data));
  } catch (error) {
    yield put(fetchRulesFailure(error.message));
  }
}

function* createRule(action) {
  try {
    const { mappingId, ...data } = action.payload;
    const response = yield call(
      axios.post,
      `${API_BASE_URL}/rules`,
      data,
      createConfig()
    );
    yield put(createRuleSuccess(response.data));
  } catch (error) {
    yield put(createRuleFailure(error.message));
  }
}

function* updateRule(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(
      axios.put,
      `${API_BASE_URL}/rules/${id}`,
      data,
      createConfig()
    );
    yield put(updateRuleSuccess(response.data));
  } catch (error) {
    yield put(updateRuleFailure(error.message));
  }
}

function* deleteRule(action) {
  try {
    const { id } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/rules/${ action.payload}`, createConfig());
    yield put(deleteRuleSuccess(id));
  } catch (error) {
    yield put(deleteRuleFailure(error.message));
  }
}

export default function* ruleSaga() {
  yield takeLatest(FETCH_RULES_REQUEST, fetchRules);
  yield takeLatest(CREATE_RULE_REQUEST, createRule);
  yield takeLatest(UPDATE_RULE_REQUEST, updateRule);
  yield takeLatest(DELETE_RULE_REQUEST, deleteRule);
}
